import { render } from "./reporteNegocios.vue?vue&type=template&id=2b146c62&scoped=true"
import script from "./reporteNegocios.vue?vue&type=script&lang=js"
export * from "./reporteNegocios.vue?vue&type=script&lang=js"

import "./reporteNegocios.vue?vue&type=style&index=0&id=2b146c62&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b146c62"]])

export default __exports__